import React from "react";

export default function HowItWorks2({ className }) {
  return (
    <svg
      width="173"
      height="173"
      viewBox="0 0 173 173"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : ""}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.4003 126.13L37.644 126.73V154.08H138.028V123.392H89.9654C102.499 113.316 113.003 103.01 121.46 92.4676L121.467 92.4592C131.062 80.3663 135.916 67.2002 135.916 53.0081C135.916 40.0151 131.855 29.3058 123.624 21.0714C115.441 12.756 103.387 8.76807 87.836 8.76807C78.7361 8.76807 70.3758 10.5502 62.7878 14.1446L62.7754 14.1505C55.2359 17.7857 49.1323 23.4369 44.4677 31.0335L44.461 31.0445L44.4544 31.0555C39.8828 38.7196 37.5224 48.1671 37.2606 59.297L37.2124 61.3441H72.94V59.3441C72.94 52.9233 74.2413 48.2944 76.5687 45.1885C78.9872 42.0029 82.2235 40.4161 86.492 40.4161C90.9364 40.4161 93.9419 41.7427 95.8941 44.1058C97.9359 46.5775 99.084 50.1639 99.084 55.1201C99.084 61.5298 96.7731 68.2468 91.9454 75.3027C87.05 82.4575 81.0112 89.3186 73.8161 95.8825L73.8096 95.8885L73.8031 95.8945C66.6756 102.513 56.8528 110.997 44.3218 121.354L44.3295 121.365L43.5245 122.037C43.4094 122.13 43.2815 122.234 43.1405 122.347C42.1548 123.142 40.5758 124.402 38.4003 126.13ZM44.0868 124.132C44.0902 124.136 44.0936 124.141 44.0971 124.145C43.0975 124.949 41.6132 126.132 39.644 127.696V152.08H136.028V125.392H84.188C85.0527 124.726 85.9083 124.06 86.7547 123.392C100.066 112.893 111.115 102.168 119.9 91.2161C129.244 79.4401 133.916 66.7041 133.916 53.0081C133.916 40.4641 130.012 30.2881 122.204 22.4801C114.524 14.6721 103.068 10.7681 87.836 10.7681C79.004 10.7681 70.94 12.4961 63.644 15.9521C56.476 19.4081 50.652 24.7841 46.172 32.0801C42.0894 38.9244 39.8091 47.3457 39.3311 57.3441C39.2996 58.0039 39.2759 58.6705 39.26 59.3441H70.94C70.94 52.6881 72.284 47.5681 74.972 43.9841C77.788 40.2721 81.628 38.4161 86.492 38.4161C91.356 38.4161 95.004 39.8881 97.436 42.8321C99.868 45.7761 101.084 49.8721 101.084 55.1201C101.084 62.0321 98.588 69.1361 93.596 76.4321C88.604 83.7281 82.46 90.7041 75.164 97.3601C68.3005 103.733 58.9724 111.808 47.1798 121.585C46.6567 122.019 46.1288 122.456 45.596 122.896C45.6546 122.857 45.6581 122.861 45.6063 122.909L45.6051 122.91C45.5865 122.927 45.5609 122.949 45.5284 122.977L45.5133 122.957L44.0868 124.132Z"
        fill="url(#paint0_linear_13741_16650)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_13741_16650"
          x1="86.9998"
          y1="7.65529e-05"
          x2="86.9998"
          y2="173"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFCEC4" />
          <stop offset="0.520833" stopColor="#FFCEC4" stopOpacity="0" />
          <stop offset="1" stopColor="#FFCEC4" />
        </linearGradient>
      </defs>
    </svg>
  );
}
